import Decorate from './components/decorate/index.vue'
import Guide from './components/guide/index.vue'
import Music from './components/music/index.vue'
import Pause from './components/pause/index.vue'
import Number from './components/number/index.vue'
import Point from './components/point/index.vue'
import Keyboard from './components/keyboard/index.vue'
import Matrix from './components/matrix/index.vue'
import Logo from './components/logo/index.vue'
import { mapState } from 'vuex'
import { transform, i18n, lan, lastRecord, speeds } from './unit/const'
import { visibilityChangeEvent, isFocus } from './unit/'
import states from './control/states'

export default {
  mounted() {
    this.render()
    window.addEventListener('resize', this.resize.bind(this), true)
  },
  data() {
    return {
      size: {},
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
      filling: ''
    }
  },
  components: { Decorate, Guide, Music, Pause, Number, Point, Keyboard, Matrix, Logo },
  computed: {
    foodLabel: () => i18n.foodCount[lan],
    levelLabel: () => i18n.level[lan],
    wallPassLabel: () => i18n.wallPass[lan],
    ...mapState([
      'matrix', 'wallPass', 'status', 'speedRun',
      'points', 'max', 'reset', 'pause', 'music', 'keyboard', 'foodCount'
    ])
  },
  methods: {
    render() {
      let filling = 0
      const size = (() => {
        const w = this.w, h = this.h, ratio = h / w
        let scale, css = {}
        if (ratio < 1.5) { scale = h / 960 }
        else {
          scale = w / 640
          filling = (h - 960 * scale) / scale / 3
          css = {
            'padding-top': Math.floor(filling) + 42 + 'px',
            'padding-bottom': Math.floor(filling) + 'px',
            'margin-top': Math.floor(-480 - filling * 1.5) + 'px'
          }
        }
        css[transform] = `scale(${scale})`
        return css
      })()
      this.size = size
      this.start()
      this.filling = filling
    },
    resize() {
      this.w = document.documentElement.clientWidth
      this.h = document.documentElement.clientHeight
      this.render()
    },
    start() {
      if (visibilityChangeEvent) {
        document.addEventListener(visibilityChangeEvent, () => { states.focus(isFocus()) }, false)
      }

      if (lastRecord) {
        // 有上次记录：恢复状态
        if (lastRecord.snake && !lastRecord.pause) {
          // 上次在游戏中且没暂停 → 继续游戏
          const speedRun = this.$store.state.speedRun
          const timeout = speeds[speedRun] / 2
          states.auto(timeout)
        }
        if (!lastRecord.snake) {
          // 上次不在游戏中 → 触发入场动画
          states.entranceAnimation()
        }
      } else {
        states.entranceAnimation()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app.js